import ApiBaseURLProps from '../other/apiBaseURL';
import axios from 'axios';
import { authorizationHeader, getAxios } from "./apiConfig";
import kycSaveApiService from './kycSaveApiService';

class VerificationService {
  // send(forwardType, customerDto, messsages) {
  //   const dtoOnly = kycSaveApiService.getObjectBeforeSavePersonalDetails(customerDto);
  //   const payload = {
  //     customerDto: dtoOnly,
  //     messages: messsages || []
  //   };
  //   return axios.post(ApiBaseURLProps.apiBaseURL + "/kyc/submit?type=" + forwardType,
  //     payload, {
  //     headers: {
  //       Authorization: "Bearer " + sessionStorage.getItem("token"),
  //     },
  //   });
  // }
  // detail(customerId) {
  //   return axios.get(ApiBaseURLProps.apiBaseURL + "/security/verification/detail?customerId=" + customerId,
  //     {
  //       ...authorizationHeader(),
  //     });
  // }

  detail(customerId) {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/kyc/kyc-verification-msg?customerId=" + customerId, {
      ...authorizationHeader(),
    });
  }
}
export default new VerificationService();